



































import Enumerable from "linq";

import { Profession, User } from "../../../../domain/user";
import { IMultiSelectableAsynchronously, IMultiSelectableConditionallyAsynchronously, ModelEditableMixin } from "../../../system";
import Component from "vue-class-component";
import { Emit, Mixins, Prop } from "vue-property-decorator";
import { ReceptionManager } from "../../../../domain/workflow/reception";
import { IMultiOrderableUserListSelectorDialogCondition, IUserListSelectorDialogCondition } from "../../../user/dialogs";
import { Department } from "../../../../domain/department";
import { IConfiguration } from "../../../../domain/configuration";
import { ProgressConditionKinds, ProgressConditionKindsName } from "../../../../domain/workflow/kinds";
import ReceptionMultiDialogSelector from "../../selectors/ReceptionMultiDialogSelector.vue";
import ProgressConditionDropDownSelector from "../../selectors/ProgressConditionDropDownSelector.vue";


@Component({
  components: {
    ReceptionMultiDialogSelector,
    ProgressConditionDropDownSelector,
  }
})
export default class ReceptionDetailManagerEditor extends Mixins(ModelEditableMixin) {
  @Prop()
  allUser: User[];

  @Prop()
  canChangedManger: boolean;

  @Prop()
  canChangeProgressContidion: boolean;

  @Prop()
  detailDepartment: Department;

  @Prop()
  displayProgressConditionKinds: ProgressConditionKinds[];

  @Prop()
  shouldShowPhoneNumber: boolean;

  @Emit()
  updateManager(): void {}

  data(): any {
    return {
      displayProgressConditionKindsIncludeInitialValue: [],
    };
  }
  managerSelector: ReceptionMultiDialogSelector;

  // this.progressConditionも同様に"選択肢にない項目"を選択することがありうるので、戻せる選択肢を設ける
  displayProgressConditionKindsIncludeInitialValue: ProgressConditionKinds[];

  mounted(): void {
    // $refsはリアクティブではない模様.マウント後に初期化.
    this.managerSelector = this.$refs.managerSelector as ReceptionMultiDialogSelector;

    this.displayProgressConditionKindsIncludeInitialValue = this.toProgressConditionKinds(this.displayProgressConditionKinds);
  }

  get managers(): User[] {
    // 順番は上から順にする
    return Enumerable.from(this.readPropertyOrDefault(d => d.managers as ReceptionManager[], []))
      .select(m => new User(
        m.staff.id,
        m.staff.name,
        m.staff.profession
          ? new Profession(m.staff.profession.id, m.staff.profession.name, m.staff.profession.category)
          : null,
        m.staff.kanaName,
        m.staff.email,
        m.staff.phone))
      .toArray();
  }

  set managers(values: User[]) {
    let index: number = 1;
    this.writeProperty(d => d.managers = values
      ? Enumerable.from(values).select(u => new ReceptionManager(index++, u)).toArray()
      : []);

    this.updateManager();
  }

  get progressCondition(): ProgressConditionKinds {
    return this.readPropertyOrDefault(d => d.route.progressCondition, ProgressConditionKinds.None);
  }

  set progressCondition(value: ProgressConditionKinds) {
    this.writeProperty(d => d.route.progressCondition = value);
    this.updateManager();
  }

  get progressConditionName(): string {
    return ProgressConditionKindsName.getDisplayName(this.progressCondition);
  }

  get multiOrderableUserListSelectorDialogCondition(): IMultiOrderableUserListSelectorDialogCondition {
    return {
      departmentId: this.detailDepartment ? this.detailDepartment.id : null,
      isMultiSelectable: (this.requiredManagers.length > 0),
      name: null,
      defaultSelectedProfessionCodes: this.defaultProfessions ? this.defaultProfessions : null,
      isMultiSingleSwitchable: true,
    };
  }

  get requiredManagers(): User[] {
    return this.readPropertyOrDefault(d => d.documentFixPahseProcessedManagers as User[], []);
  }

  get defaultProfessions(): string[] {
    const config = this.$store.getters.configuration as IConfiguration;
    return config.behavior.user.finder.doctorProfessionCodes;
  }

  get managerStyle(): any {
    return {
      backgroundColor: this.hasInvalidManager ? this.alertBackgroundColor : null,
    };
  }

  get hasInvalidManager(): boolean {
    return Enumerable.from(this.managers)
      .any(m => this.isInvalidUser(m));
  }

  get progressConditionEnable(): boolean {
    return 1 < this.displayProgressConditionKindsIncludeInitialValue.length;
  }

  get alertBackgroundColor(): string {
    return this.$configuration.style.alertIndication.backgroundColor;
  }

  get alertColor(): string {
    return this.$configuration.style.alertIndication.color;
  }

  get multiOrderableListSelectDialog(): IMultiSelectableAsynchronously<User> & IMultiSelectableConditionallyAsynchronously<User, IUserListSelectorDialogCondition> {
    return this.$commonDialogs.user.multiOrderableListSelector;
  }

  selectManagers(): void {
    this.managerSelector.select();
  }

  selectorManagerStyle(user: User): any {
    return {
      color: this.isInvalidUser(user) ? this.alertColor : null,
    };
  }

  toProgressConditionKinds(items: ProgressConditionKinds[]): ProgressConditionKinds[] {
    // ProgressConditionKinds[]に、編集開始時に選択されている記載設定を追加
    return Enumerable.from(items.concat(this.progressCondition))
      .distinct().orderBy(p => p).toArray();
  }

  private isInvalidUser(user: User): boolean {
    if (!this.allUser || (this.allUser.length < 1)) { return false; }

    return !Enumerable.from(this.allUser).any(u => u.id === user.id);
  }
}
